import { useDispatch } from 'store/hooks';
import { loadShareUsersAsync } from './thunks';

export const useDispatchLoadShareUsers = () => {
    const dispatch = useDispatch();
    return () => {
        dispatch(loadShareUsersAsync());
    };
};
